/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

//------------------------------------------------------
// Feedback Preview Slider
//------------------------------------------------------
(function() {
  'use strict';
  
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFeedbackSlider);
  } else {
    initFeedbackSlider();
  }
  
  function initFeedbackSlider() {
    const containers = document.querySelectorAll('.flagvibe-feedback-preview');
    
    containers.forEach(function(container) {
      const track = container.querySelector('.fpreview-track');
      const cards = container.querySelectorAll('.fpreview-card:not(.fpreview-clone)');
      const leftArrow = container.querySelector('.fpreview-arrow--left');
      const rightArrow = container.querySelector('.fpreview-arrow--right');
      
      if (!track || !cards.length || !leftArrow || !rightArrow) return;
      
      let currentIndex = 0;
      const totalCards = cards.length;
      
      // Start at position 1 (first real card, after clone)
      track.style.transform = 'translateX(-14.2857%)';
      
      // Update track position
      function updateTrack(index, instant) {
        if (instant) {
          track.classList.add('no-transition');
        }
        
        // Position: clone(-1) + cards(0,1,2,3,4) + clone(5)
        const translateX = -((index + 1) * 14.2857);
        track.style.transform = `translateX(${translateX}%)`;
        
        if (instant) {
          // Force reflow then remove no-transition
          track.offsetHeight;
          track.classList.remove('no-transition');
        }
      }
      
      // Go to next card
      function nextCard() {
        currentIndex++;
        updateTrack(currentIndex);
        
        // If we're at the clone of first card, jump to real first card
        if (currentIndex >= totalCards) {
          setTimeout(function() {
            currentIndex = 0;
            updateTrack(currentIndex, true);
          }, 300);
        }
      }
      
      // Go to previous card  
      function prevCard() {
        currentIndex--;
        updateTrack(currentIndex);
        
        // If we're at the clone of last card, jump to real last card
        if (currentIndex < 0) {
          setTimeout(function() {
            currentIndex = totalCards - 1;
            updateTrack(currentIndex, true);
          }, 300);
        }
      }
      
      // Event listeners
      rightArrow.addEventListener('click', nextCard);
      leftArrow.addEventListener('click', prevCard);
      
      // Touch support with real drag feeling
      let startX = null;
      let isDragging = false;
      let dragOffset = 0;
      
      function getCurrentTranslate() {
        return -((currentIndex + 1) * 14.2857);
      }
      
      container.addEventListener('touchstart', function(e) {
        startX = e.touches[0].clientX;
        isDragging = false;
        dragOffset = 0;
      });
      
      container.addEventListener('touchmove', function(e) {
        if (!startX) return;
        
        const currentX = e.touches[0].clientX;
        const diffX = currentX - startX;
        
        // Only start dragging if horizontal movement is significant
        if (Math.abs(diffX) > 10) {
          isDragging = true;
          e.preventDefault(); // Prevent scrolling
          
          // Calculate drag offset as percentage
          dragOffset = (diffX / container.offsetWidth) * 14.2857;
          
          // Apply drag with current position
          const baseTranslate = getCurrentTranslate();
          track.style.transform = `translateX(${baseTranslate + dragOffset}%)`;
          track.classList.add('no-transition');
        }
      });
      
      container.addEventListener('touchend', function(e) {
        if (!startX) return;
        
        const endX = e.changedTouches[0].clientX;
        const diffX = startX - endX;
        
        // Remove transition lock
        track.classList.remove('no-transition');
        
        if (isDragging) {
          // Check if drag was strong enough
          const threshold = container.offsetWidth * 0.25; // 25% threshold
          
          if (Math.abs(diffX) > threshold) {
            if (diffX > 0) {
              nextCard(); // Swipe left = next
            } else {
              prevCard(); // Swipe right = previous  
            }
          } else {
            // Snap back to current position
            updateTrack(currentIndex);
          }
        }
        
        // Reset
        startX = null;
        isDragging = false;
        dragOffset = 0;
      });
      
      // Keyboard support
      container.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowLeft') {
          prevCard();
          e.preventDefault();
        } else if (e.key === 'ArrowRight') {
          nextCard();
          e.preventDefault();
        }
      });
      
      // Make container focusable for keyboard navigation
      container.setAttribute('tabindex', '0');
    });
  }
})();

//------------------------------------------------------
// Feedback Slider Marquee Carousel
//------------------------------------------------------
// Working Custom Marquee with Lazy Loading
class FeedbackCarousel {
  constructor(element) {
    this.carousel = element;
    this.track = this.carousel.querySelector('.feedback-carousel__track');
    this.speed = parseInt(this.carousel.dataset.speed) || 4000;
    this.slides = Array.from(this.track.children);
    this.slideWidth = 270; // 250px + 20px gap
    // FIXED: More accurate width calculation
    const slideCount = this.slides.length / 2;
    this.singleSetWidth = (this.slideWidth * slideCount) - 20; // Remove last gap
    this.position = 0;
    this.isRunning = false;
    this.animationId = null;
    this.isInitialized = false;
    this.isVisible = false;
    
    // Touch/Drag properties
    this.isDragging = false;
    this.startX = 0;
    this.startY = 0;
    this.dragStartPosition = 0;
    this.isUserInteracting = false;
    
    // Lazy loading properties
    this.lazyImages = [];
    this.imageLoadBuffer = 3; // Load 3 images ahead
    
    this.init();
  }
  
  init() {
    if (this.slides.length === 0) return;
    
    // FIXED: Calculate real width from DOM instead of guessing
    const firstSlide = this.slides[0];
    const slideRect = firstSlide.getBoundingClientRect();
    const trackRect = this.track.getBoundingClientRect();
    
    // Get computed gap from CSS
    const computedStyle = getComputedStyle(this.track);
    const gap = parseInt(computedStyle.gap) || 20;
    
    // Real slide width including gap
    this.slideWidth = slideRect.width + gap;
    this.singleSetWidth = this.slideWidth * (this.slides.length / 2) - gap; // Remove final gap
    
    console.log('Real slideWidth:', this.slideWidth, 'singleSetWidth:', this.singleSetWidth);
    
    // Calculate speed
    const baseSpeed = 4000;
    const speedMultiplier = baseSpeed / this.speed;
    this.pixelsPerFrame = Math.max(0.2, Math.min(3, speedMultiplier));
    
    // Setup Intersection Observer for lazy loading
    this.setupIntersectionObserver();
    this.setupEventListeners();
    this.setupLazyLoading();
  }
  
  setupLazyLoading() {
    // Find all lazy images
    this.lazyImages = Array.from(this.carousel.querySelectorAll('.feedback-image--lazy'));
    
    if (this.lazyImages.length === 0) return;
    
    // Create intersection observer for lazy images
    const lazyImageObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          // Force load the image
          img.loading = 'eager';
          // Remove lazy class and observer
          img.classList.remove('feedback-image--lazy');
          lazyImageObserver.unobserve(img);
        }
      });
    }, {
      rootMargin: '100px 0px', // Load when 100px before entering viewport
      threshold: 0.1
    });
    
    // Observe all lazy images
    this.lazyImages.forEach(img => {
      lazyImageObserver.observe(img);
    });
  }
  
  setupIntersectionObserver() {
    // Only initialize carousel when it becomes visible
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.isInitialized) {
          this.isVisible = true;
          this.isInitialized = true;
          
          // IMPORTANT: Recalculate dimensions when becoming visible
          // In case of responsive layout changes
          this.recalculateDimensions();
          
          this.start();
          console.log('Feedback carousel initialized (now visible)');
        } else if (!entry.isIntersecting && this.isInitialized) {
          this.isVisible = false;
          this.pause();
        } else if (entry.isIntersecting && this.isInitialized) {
          this.isVisible = true;
          if (!this.isUserInteracting) this.start();
        }
      });
    }, {
      rootMargin: '50px 0px',
      threshold: 0.1
    });
    
    observer.observe(this.carousel);
  }
  
  recalculateDimensions() {
    // Recalculate dimensions when needed (responsive changes)
    const firstSlide = this.slides[0];
    const slideRect = firstSlide.getBoundingClientRect();
    const computedStyle = getComputedStyle(this.track);
    const gap = parseInt(computedStyle.gap) || 20;
    
    this.slideWidth = slideRect.width + gap;
    this.singleSetWidth = this.slideWidth * (this.slides.length / 2) - gap;
    
    console.log('RECALCULATED - slideWidth:', this.slideWidth, 'singleSetWidth:', this.singleSetWidth);
    console.log('Slide actual width:', slideRect.width, 'CSS gap:', gap);
    console.log('Total slides:', this.slides.length, 'Set count:', this.slides.length / 2);
  }
  
  setupEventListeners() {
    // Mouse events
    this.carousel.addEventListener('mousedown', this.handleStart.bind(this), { passive: false });
    this.carousel.addEventListener('mousemove', this.handleMove.bind(this), { passive: false });
    this.carousel.addEventListener('mouseup', this.handleEnd.bind(this), { passive: true });
    this.carousel.addEventListener('mouseleave', this.handleEnd.bind(this), { passive: true });
    
    // Touch events
    this.carousel.addEventListener('touchstart', this.handleStart.bind(this), { passive: false });
    this.carousel.addEventListener('touchmove', this.handleMove.bind(this), { passive: false });
    this.carousel.addEventListener('touchend', this.handleEnd.bind(this), { passive: true });
    
    // Hover pause (only when visible)
    this.carousel.addEventListener('mouseenter', () => {
      if (!this.isDragging && this.isVisible) this.pause();
    });
    this.carousel.addEventListener('mouseleave', () => {
      if (!this.isDragging && !this.isUserInteracting && this.isVisible) this.start();
    });
    
    this.carousel.addEventListener('contextmenu', (e) => e.preventDefault());
  }
  
  handleStart(e) {
    // Don't allow interaction until initialized
    if (!this.isInitialized) return;
    
    this.isDragging = true;
    this.isUserInteracting = true;
    this.pause();
    
    const point = e.touches ? e.touches[0] : e;
    this.startX = point.clientX;
    this.startY = point.clientY;
    this.dragStartPosition = this.position;
    
    this.carousel.style.cursor = 'grabbing';
    
    // Preload nearby images when user starts dragging
    this.preloadNearbyImages();
    
    e.preventDefault();
  }
  
  preloadNearbyImages() {
    // Calculate which images might become visible during drag
    const currentSlideIndex = Math.abs(Math.floor(this.position / this.slideWidth));
    const bufferRange = 6; // Load 6 slides in each direction
    
    this.lazyImages.forEach(img => {
      const slideIndex = parseInt(img.dataset.slideIndex) || 0;
      if (Math.abs(slideIndex - currentSlideIndex) <= bufferRange) {
        img.loading = 'eager';
        img.classList.remove('feedback-image--lazy');
      }
    });
  }
  
  handleMove(e) {
    if (!this.isDragging || !this.isInitialized) return;
    
    const point = e.touches ? e.touches[0] : e;
    const currentX = point.clientX;
    const currentY = point.clientY;
    
    // Check for vertical scroll
    const deltaX = Math.abs(currentX - this.startX);
    const deltaY = Math.abs(currentY - this.startY);
    
    if (deltaY > deltaX && deltaY > 10) {
      this.handleEnd(e);
      return;
    }
    
    e.preventDefault();
    
    // Calculate new position from drag
    const dragDistance = currentX - this.startX;
    this.position = this.dragStartPosition + dragDistance;
    
    this.updateTransform();
  }
  
  handleEnd(e) {
    if (!this.isDragging || !this.isInitialized) return;
    
    this.isDragging = false;
    this.carousel.style.cursor = 'grab';
    
    // Resume after delay (only if still visible)
    setTimeout(() => {
      this.isUserInteracting = false;
      if (this.isVisible) this.start();
    }, 2000);
  }
  
  start() {
    if (this.isRunning || this.isUserInteracting || !this.isInitialized || !this.isVisible) return;
    this.isRunning = true;
    this.animate();
  }
  
  pause() {
    this.isRunning = false;
    if (this.animationId) {
      cancelAnimationFrame(this.animationId);
    }
  }
  
  updateTransform() {
    this.track.style.transform = `translateX(${this.position}px)`;
  }
  
  animate() {
    if (!this.isRunning || this.isDragging || !this.isVisible) return;
    
    // Move position forward (to the left)
    this.position -= this.pixelsPerFrame;
    
    // DEBUG: Log exact position values
    if (Math.abs(this.position + this.singleSetWidth) < 10) {
      console.log('Close to reset - Position:', this.position, 'Target:', -this.singleSetWidth);
    }
    
    // Simple reset when one set is complete
    if (this.position <= -this.singleSetWidth) {
      console.log('RESET TRIGGERED - From:', this.position, 'To: 0');
      this.position = 0;
    }
    
    this.updateTransform();
    this.animationId = requestAnimationFrame(() => this.animate());
  }
}

// Initialize everything
function initFeedbackSection() {
  document.querySelectorAll('.feedback-carousel').forEach(carousel => {
    const hasImages = carousel.querySelectorAll('.feedback-carousel__slide img').length > 0;
    if (hasImages) {
      new FeedbackCarousel(carousel);
    }
  });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFeedbackSection);
} else {
  initFeedbackSection();
}

// Reinitialize in Shopify theme editor
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', initFeedbackSection);
}